<template>
  <v-list-tile :key="entity.id" avatar @click="!adminActions ? downloadEntity(entity) : null">
    <v-list-tile-avatar mr-2>
      <calendar-event-icon-status
        :badge-color="getBadgeColor()"
        event-hover-color="primary"
        event-hover-icon="mdi-calendar-edit"
        :status="entity.status"
        @click="editEntity()"
      ></calendar-event-icon-status>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title
        v-for="field in levelZero"
        :key="field.name"
        v-html="$t(entity[field.name])"
      ></v-list-tile-title>
      <v-list-tile-sub-title v-if="displayLevel >= 1">
        <v-layout row>
          <v-flex v-for="field in levelOne" :key="field.name" class="text-sm-left" xs3>
            <b v-if="field.showLabel">{{ $t(field.label) }}:</b>
            <template v-if="Array.isArray(entity[field.name])">
              <span v-for="(value, v) in entity[field.name]" :key="v">
                {{ $t(value[field.primaryField]) }}
              </span>
            </template>
            <template v-else>
              <span
                v-if="
                  ['created_at', 'updated_at', 'date'].includes(field.name) && entity[field.name]
                "
              >
                {{ entity[field.name] | moment('DD/MM/YYYY') }}
              </span>
              <span v-else-if="['time'].includes(field.name) && entity[field.name]">
                {{ [entity[field.name], 'HH:mm:ss'] | moment('HH:mm') }}
              </span>
              <span v-else>{{ $t(entity[field.name]) }}</span>
            </template>
          </v-flex>
        </v-layout>
      </v-list-tile-sub-title>
      <v-list-tile-sub-title v-if="displayLevel >= 2">
        <span v-for="field in levelTwo" class="mr-2" :key="field.name">
          <b v-if="field.showLabel">{{ $t(field.label) }}:</b>
          {{ $t(entity[field.name]) }}
        </span>
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <template v-if="adminActions">
        <v-menu>
          <v-btn slot="activator" color="primary" dark flat min-width="100">
            {{ $t('Acciones') }}
          </v-btn>
          <v-list>
            <v-list-tile @click="changeStatus('confirmed')">
              <v-list-tile-title>
                {{ $t('Confirmado') }}
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="changeStatus('in_progress')">
              <v-list-tile-title>
                {{ $t('Sin confirmar') }}
              </v-list-tile-title>
            </v-list-tile>

            <v-list-tile @click="deleteEvent()">
              <v-list-tile-title>
                {{ $t('Eliminar') }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </template>
      <v-btn icon flat v-if="!adminActions">
        <v-icon color="primary">mdi-chevron-right</v-icon>
      </v-btn>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import AruListItemMixin from '@/mixins/list/AruListItemMixin.js';
import CalendarEventIconStatus from '@/components/commons/CalendarEventIconStatus.vue';
import apiCtrl from '@/services/api/abstract/abstract-api.js';
// const moment = require('moment')
// require('moment/locale/es')
export default {
  mixins: [AruListItemMixin],
  props: {
    adminActions: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CalendarEventIconStatus,
  },
  methods: {
    getBadgeColor() {
      switch (this.entity.status) {
        case 'in_progress':
          return 'grey lighten-1';
        case 'confirmed':
          return 'primary';
        case 'error':
          return 'error';
        default:
          return 'grey lighten-1';
      }
    },
    editEntity() {
      this.$emit('editEntity', this.entity);
      console.log(this.entity);
    },
    changeStatus(status) {
      apiCtrl
        .post('/calendar-event/change-status/' + this.entity.id, {
          status: status,
        })
        .then(res => {
          console.log({ DOCUEMTNE: res });
          this.entity.status = status;
        });
    },
    deleteEvent() {
      let toDelete = this.entity;
      apiCtrl.delete('/calendar-event/' + this.entity.id).then(res => {
        console.log(res);
        this.$emit('entityDeleted', toDelete);
      }),
        console.log(this.entity);
    },
  },
};
</script>

<style></style>
